import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class AffiliateKitItem {
    @observable id?: number;

    @observable s3key?: string;
    @observable parent?: string;
    @observable order?: number;
    @observable originalName!: string;
    @observable displayName!: string;
    @observable type!: string;

    constructor(affiliateKitItem?: ModelProperties<AffiliateKitItem>) {
        if (affiliateKitItem) {
            construct(this, affiliateKitItem);
        }
    }
}